import React, {FC, PropsWithChildren} from 'react';
import {TrakLowerBackground} from '../../components/trak-lower-bg/trak-lower-bg.component';
import {ReactComponent as TrakLogoLarge} from '../../assets/trak-logo-large.svg';

type Props = { 
  padTop?:boolean;
}

export const AuthPageLayout: FC<PropsWithChildren<Props>> = ({children, padTop}) => (
  <div className="flex flex-1 flex-col bg-white relative">
    <TrakLowerBackground />
    <div className={`flex flex-col justify-center items-center py-10 md:py-20 z-10 ${padTop && 'pt-20'}`}>
      <TrakLogoLarge width={'80%'} className="h-20" />
      <div className=" w-4/5 flex flex-col gap-2  my-10 relative">{children}</div>
    </div>
  </div>
);
